module.exports = __webpack_public_path__ + "static/media/picard2.7f2057e4.jpg";